<div class="dialog">
	<ng-container mat-dialog-content>
		<div class="dialog__content">
			<p class="dialog__title">Restart Game</p>
			<p>The current progress will be lost.</p>
		</div>
	</ng-container>
	<ng-container mat-dialog-actions>
		<div class="dialog__actions">
			<button
				(click)="resetGame()"
				type="button"
				class="primary"
			>
				<mat-icon svgIcon="refresh" />
				Restart
			</button>
			<button
				(click)="closeDialog()"
				type="button"
				class="secondary"
			>
				Cancel
			</button>
		</div>
	</ng-container>
</div>
